module.exports = __webpack_public_path__ + "static/img/chanta (1).594ef90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (1).jpg
// module id = ELEB
// module chunks = 0